'use client';

import { Video } from 'lucide-react';

import { DialogCloseButton } from '@/components/dialog-close';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';

import { COPY } from '@/shared/constants/copies';

interface IUnsavedVideoDialogProps {
	open: boolean;
	unsavedCount: number;
	onClose: () => void;
	onGoToVideo: () => void;
	onSubmitAnyway: () => void;
}

function UnsavedVideoDialog({
	open,
	unsavedCount,
	onClose,
	onGoToVideo,
	onSubmitAnyway,
}: IUnsavedVideoDialogProps) {
	return (
		<Dialog
			open={open}
			onOpenChange={(isOpen) => !isOpen && onClose()}
		>
			<DialogContent className="max-w-md">
				<DialogCloseButton className="absolute right-4 top-4" />
				<div className="text-center">
					<div className="mb-4 flex justify-center">
						<div className="flex h-12 w-12 items-center justify-center rounded-full bg-amber-100">
							<Video className="h-6 w-6 text-amber-600" />
						</div>
					</div>
					<DialogTitle className="mb-2 text-lg font-semibold text-gray-900">
						{unsavedCount > 1 ? "Your videos aren't saved" : "Your video isn't saved"}
					</DialogTitle>
					<DialogDescription className="mb-6 text-sm text-gray-600">
						{COPY.fields.videoUnsavedOnSubmit(unsavedCount)}
					</DialogDescription>
					<div className="flex gap-3">
						<Button
							type="button"
							variant="outline"
							className="flex-1"
							onClick={onSubmitAnyway}
						>
							Submit anyway
						</Button>
						<Button
							type="button"
							variant="default"
							className="flex-1"
							onClick={onGoToVideo}
						>
							{unsavedCount > 1 ? 'Save videos' : 'Save video'}
						</Button>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	);
}

export default UnsavedVideoDialog;
